import { Button, Icon, Popover, Space, Typography } from '@sravni/react-design-system';
import { useBoolean } from '@sravni/react-utils';

import { ContextMenuSvg } from '@src/components/icons/contextMenu';
import { Info } from '@src/components/icons/info';

import { ADENGI_TITLE } from '../ADengiBanner/ADengiBanner.config';

import styles from './SponsoredMenu.module.scss';

export function SponsoredMenu({ company, token }: { company: string; token: string }) {
  const [visible, setVisible] = useBoolean(false);
  const [copied, setCopied] = useBoolean(false);

  const copy = () => navigator.clipboard.writeText(token).then(setCopied.on).catch(setCopied.off);

  return (
    <Popover
      className={styles.popoverContainer}
      visible={visible}
      onClose={() => {
        setVisible.off();
        setCopied.off();
      }}
      content={
        <Space direction="column" size={8}>
          <Typography.Text className={styles.text}>{ADENGI_TITLE}</Typography.Text>
          <Typography.Text className={styles.text}>{company} </Typography.Text>
          <Button variant="text" color="blue" onClick={copy}>
            <Icon color="blue" icon={<Info />} />
            {/* пришлось стили накинуть иначе темный текст */}
            <Typography.Text className={styles.buttonText}>
              {copied ? 'Скопирован' : 'Скопировать токен'}
            </Typography.Text>
          </Button>
        </Space>
      }
    >
      <div className={styles.container}>
        <Icon icon={<ContextMenuSvg />} onClick={setVisible.on} />
      </div>
    </Popover>
  );
}
